module.exports = __webpack_public_path__ + "static/media/steps_plus_logo.cb9f96a2.png";